import React from "react";
import "./styles/tailwind.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { bootstrapPwa } from "./services/pwa";
import { createRoot } from 'react-dom/client';

const root = createRoot(document.getElementById('root')!);
root.render(<React.StrictMode>
  <BrowserRouter basename={process.env.PUBLIC_URL}>
    <App />
  </BrowserRouter>
</React.StrictMode>);

bootstrapPwa();